import { css } from 'styled-components';
import { breakpoints } from 'modules/breakpoints';
import { theme } from 'modules/tetrisTheme';
const stickyStyles = css `
  z-index: 1;
  background-color: ${theme.semantic.surface.primary};
  position: sticky;

  ${({ $stickyColumn }) => $stickyColumn === 'left' &&
    css `
      left: 0;
    `};
  ${({ $stickyColumn }) => $stickyColumn === 'right' &&
    css `
      right: 0;
    `};
`;
const hiddenStyles = css `
  display: none;
`;
export const tableCellStyles = css `
  margin: 0;
  text-align: left;
  vertical-align: middle;
  min-width: min-content;
  padding: 0 var(--table-cell-padding);

  ${breakpoints.xs} {
    padding: 0 ${theme.spacing.sm};
  }

  ${({ $hide }) => $hide && hiddenStyles};
  ${({ $stickyColumn }) => $stickyColumn !== undefined && stickyStyles};
`;
